<div class="decline-mapping-grid-cells">
  <ng-container *ngIf="row">
    <ng-container *ngIf="editing; else viewTpl">
      <input
        #nameInput
        class="dm-cat-input"
        [ngModel]="host?.editDraft"
        (ngModelChange)="onDraftChange($event)"
        (keydown)="onInputKeydown($event)"
        (blur)="onInputBlur()"
      />
    </ng-container>
    <ng-template #viewTpl>
      <div class="dm-row-name" (click)="onNameClick()" title="Click to rename">{{ row.name }}</div>
      <div class="dm-row-mapped">{{ mappedCount }} mapped</div>
    </ng-template>
  </ng-container>
</div>
